module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPPz84aGhgCZ/xWKwgSCxRN0qwF2xRVrmwxqnwhqnxZkmh1cjQxflghfkxBbjxJPgxdMfw5PgwpPhQZPgwJPgzM8Yj0AADEAAC0AAAgICCQAABwAABQABAwAAAQAAP///yH5BAEAAB8ALAAAAAAgACAAAAWB4CeOZGmeaKqubOu+cCzPdG0GgX3itef/wKAwWMp8cEhk5zL8JXEekfH4rFoDnqpvpL0+s90r2AvVhLVjsu+crKzJ0DTU6pZfOXZ7HI7b5MV6aGxffFh5XIR8b0kfUVSFiiJRXh4bGBZlGItIHgAjek1BXy48Ojs5pqmqq6ytrjMhADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadW_S7.gif
// module id = xAZG
// module chunks = 44